import { render, staticRenderFns } from "./marketControlsList.vue?vue&type=template&id=a4a4c30c&scoped=true&"
import script from "./marketControlsList.vue?vue&type=script&lang=js&"
export * from "./marketControlsList.vue?vue&type=script&lang=js&"
import style0 from "./marketControlsList.vue?vue&type=style&index=0&id=a4a4c30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a4c30c",
  null
  
)

export default component.exports